import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Heading, Box, Text } from "grommet";
import React from "react";
import { useLocation } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import { TournamentRow } from "./TournamentRow";
import { newTournamentIcon } from "./TournamentsManagement";
import { TournamentViewModel, getTournaments } from "./TournamentsStore";
import { usePermission } from "../account/AccountStore";
import { set } from "lodash";

/* @ts-ignore */
const archive = <FontAwesomeIcon size="xl" icon={["fad", "archive"]}></FontAwesomeIcon>;

const TournamentsList = () => {
    const hasWritePermission = usePermission("sport:tournaments.write");

    const [tournaments, setTournaments] = React.useState([] as TournamentViewModel[]);
    let { pathname } = useLocation();

    const [loading, setLoading] = React.useState(true);

    const [showArchive, setShowArchive] = React.useState(false);

    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);

    React.useEffect(() => {
        setLoading(true);
        getTournaments(page * pageSize, pageSize, showArchive).then((tournaments) => {
            setTournaments(tournaments);
            setLoading(false);
        });

        return () => {};
    }, [pathname, showArchive]);

    const loadMore = () => {
        setLoading(true);
        getTournaments((page + 1) * pageSize, pageSize, showArchive).then((newTournaments) => {

            setPage(page + 1);
            setTournaments([...tournaments, ...newTournaments]);
            setLoading(false);
        });
    };

    return (
        <>
            <Heading size="small">Tournaments</Heading>
            <Box direction="row" pad={"small"} gap="small">
                {hasWritePermission && <CustomButton path={"/tournaments/create"} icon={newTournamentIcon} label="New Tournament"></CustomButton>}
                <CustomButton primary={showArchive} icon={archive} label={showArchive ? "Show Active" : "Show Archive"} onClick={() => setShowArchive(!showArchive)}></CustomButton>
            </Box>
            <Box gap="small">
                <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                    Tournaments
                </Text>
                <SkeletonWrapper loading={loading}>
                    <Box gap="small">
                        {tournaments.map((tournament) => (
                            <TournamentRow key={tournament.id} tournament={tournament}>
                                <></>
                            </TournamentRow>
                        ))}
                        {tournaments.length == (page + 1) * 10 && <CustomButton label="Load More" onClick={loadMore}></CustomButton>}
                    </Box>
                </SkeletonWrapper>
            </Box>
        </>
    );
};

export default TournamentsList;
